import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { ApiService } from 'src/app/services/api.service';
import { CoreService } from 'src/app/services/core.service';
import { UsersService } from 'src/app/services/users.service';
import * as moment from 'moment';
import { Observable, of } from 'rxjs';
import { LoaderService } from 'src/app/services/loader.service';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  dataProfile: any = null;

  constructor(
    private loaderService: LoaderService,
    private coreService: CoreService,
    public cookies: CookieService,
    public apiServices: ApiService,
    public router: Router,
    public apiUsersServices: UsersService,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.getDataProfile();
  }

  getDataProfile(): void {
    this.loaderService.show();

    this.apiUsersServices.me().subscribe({
      next: (value) => {
        if (!value.status) {
          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: {
              text: 'Hubo un error al procesar tu solicitud',
            },
          });
          this.loaderService.hide();
          return;
        }

        this.dataProfile = value.data;

        if (this.dataProfile.phone?.startsWith('52')) {
          this.dataProfile.phone = this.dataProfile.phone.substring(2);
        }

        this.loadProfileLocation();
      },
      error: (err) => {
        console.error(err);

        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: {
            text: 'Hubo un error al procesar tu solicitud',
          },
        });

        this.loaderService.hide();
      },
    });
  }

  private loadProfileLocation(): void {
    const zipCode = this.dataProfile?.main_zip_code;
    const localityId = Number(this.dataProfile?.locality_id);

    if (!zipCode || zipCode.length !== 5 || !localityId) {
      this.loaderService.hide();
      return;
    }

    this.apiUsersServices.getLocalitiesByZipCode(zipCode).subscribe({
      next: (value) => {
        if (value.status) {
          const localities = (value.data ?? []).flat(Infinity);

          const locality = localities.find(
            (item: any) => Number(item?.id) === localityId,
          );
          if (locality) {
            this.dataProfile.locality = locality;
            this.dataProfile.locality_id = locality.id;
            this.dataProfile.municipality_id = locality.municipality?.id ?? '';
            this.dataProfile.municipality = locality.municipality?.name ?? '';
            this.dataProfile.state_id = locality.state?.id ?? '';
            this.dataProfile.state = locality.state?.name ?? '';
          }
        }
        this.loaderService.hide();
      },
      error: (err) => {
        console.error(err);
        this.loaderService.hide();
      },
    });
  }

  openDialogEditProfile(): void {
    if (!this.dataProfile) {
      return;
    }

    const dialogRef = this.dialog.open(DialogEditProfile, {
      width: '720px',
      maxWidth: '94vw',
      height: 'auto',
      maxHeight: '90vh',
      backdropClass: 'nina-dialog-backdrop',
      autoFocus: false,
      data: this.dataProfile,
    });

    dialogRef.afterClosed().subscribe((updated: boolean) => {
      if (updated) {
        this.getDataProfile();
      }
    });
  }

  sendRegisterCarlos(): void {
    const now = new Date();

    const fechaRegistroApp = `${now.getFullYear()}-${String(
      now.getMonth() + 1,
    ).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}T${String(
      now.getHours(),
    ).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;

    const birth = new Date(this.dataProfile.birthdate);

    const fechaNacimiento = `${birth.getUTCFullYear()}-${String(
      birth.getUTCMonth() + 1,
    ).padStart(2, '0')}-${String(birth.getUTCDate()).padStart(2, '0')}`;

    let sexo = 'Otro';

    if (this.dataProfile.gender === 'M') {
      sexo = 'Masculino';
    } else if (this.dataProfile.gender === 'F') {
      sexo = 'Femenino';
    } else if (this.dataProfile.gender === 'O') {
      sexo = this.dataProfile.gender_value || 'Otro';
    }

    const bodyReq: any = {
      idCliente: this.dataProfile.id,
      nombres: this.dataProfile.names,
      paterno: this.dataProfile.last_name,
      materno: this.dataProfile.last_name2,
      celular: this.dataProfile.phone,
      correo: this.dataProfile.email || '',
      fechaNacimiento,
      sexo,
      codigoPostal: this.dataProfile.main_zip_code,
      colonia: this.dataProfile.locality?.name || '',
      fechaRegistroApp,
    };

    this.apiServices.insertaModificaCliente(bodyReq).subscribe({
      next: () => {},
      error: (err) => {
        console.error('ERROR', err);
      },
    });
  }

  formatBirthdate(value: any): string {
    if (!value) {
      return '—';
    }

    const match = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);

    return match ? `${match[3]}/${match[2]}/${match[1]}` : '—';
  }

  deleteAccount(): void {
    if (!this.dataProfile?.id) {
      this.coreService.emitSubjet.next({
        type: 'Snackbar',
        payload: {
          text: 'No se pudo identificar tu cuenta',
        },
      });

      return;
    }

    const dialogRef = this.dialog.open(DialogDeleteAccount, {
      width: '460px',
      maxWidth: '92vw',
      height: 'auto',
      maxHeight: '90vh',
      backdropClass: 'nina-dialog-backdrop',
      data: {
        name: this.dataProfile.names,
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (!confirmed) {
        return;
      }

      this.loaderService.show();

      this.apiUsersServices.deleteAccount(this.dataProfile.id).subscribe({
        next: (value) => {
          this.loaderService.hide();

          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: {
              text:
                value?.message || 'Tu cuenta ha sido eliminada correctamente',
            },
          });

          localStorage.removeItem('Cart');
          localStorage.removeItem('attempts');
          localStorage.removeItem('userPhone');

          this.cookies.delete('UL');
          this.cookies.delete('Token');
          this.cookies.delete('CartUD');
          this.cookies.delete('Data');
          this.cookies.delete('Branch');
          this.cookies.delete('BranchTemp');
          this.cookies.delete('Shippeable');

          this.coreService.emitSubjet.next({
            type: 'RefreshLoged',
            payload: null,
          });

          this.router.navigate(['/home']);
        },
        error: (err) => {
          this.loaderService.hide();

          console.error('Error al eliminar cuenta:', err);

          this.coreService.emitSubjet.next({
            type: 'Snackbar',
            payload: {
              text: 'Hubo un error al eliminar tu cuenta. Inténtalo nuevamente.',
            },
          });
        },
      });
    });
  }

  logout(): void {
    this.loaderService.show();

    this.apiUsersServices.logout().subscribe({
      next: (value) => {
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: {
            text: value.message,
          },
        });

        if (value.status) {
          try {
            localStorage.removeItem('Cart');
            localStorage.removeItem('attempts');
            localStorage.removeItem('userPhone');
            sessionStorage.removeItem('nina_coupons_checked');
            localStorage.removeItem('MyAddressSelected')
            localStorage.removeItem('ResumeData')
            this.cookies.delete("MyAddress")
            this.cookies.delete("DataPromo")
            this.cookies.delete('uid');
            this.cookies.delete('UL');
            this.cookies.delete('ss');
            this.cookies.delete("Shippeable")
            this.cookies.delete("Data")
            this.cookies.delete("CartUD")

            this.coreService.emitSubjet.next({
              type: 'Snackbar',
              payload: {
                text: 'Session Cerrada',
              },
            });

            this.coreService.emitSubjet.next({
              type: 'RefreshLoged',
              payload: null,
            });

            this.coreService.emitSubjet.next({
              type: 'Cart',
              payload: null,
            });

            this.router.navigate(['/home']);
          } catch (err) {
            this.coreService.emitSubjet.next({
              type: 'RefreshLoged',
              payload: null,
            });

            this.coreService.emitSubjet.next({
              type: 'Snackbar',
              payload: {
                text: 'Error',
              },
            });

            this.coreService.emitSubjet.next({
              type: 'Cart',
              payload: null,
            });

            this.cookies.delete('UL');
            this.cookies.delete('ss');

            localStorage.removeItem('Cart');
            localStorage.removeItem('attempts');
            localStorage.removeItem('userPhone');
            sessionStorage.removeItem('nina_coupons_checked');
          }
        }

        this.loaderService.hide();
      },
      error: (err) => {
        console.error(err);

        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: {
            text: 'Hubo un error al procesar tu solicitud',
          },
        });

        this.cookies.delete('UL');
        this.loaderService.hide();
      },
    });
  }

  openDialogChangePassword(): void {
    const dialogRef = this.dialog.open(DialogChangePassword, {
      width: '460px',
      maxWidth: '92vw',
      height: 'auto',
      maxHeight: '90vh',
      backdropClass: 'nina-dialog-backdrop',
      autoFocus: false,
      data: null,
    });

    dialogRef.afterClosed().subscribe(() => {});
  }
}

@Component({
  selector: 'dialog-change-password',
  templateUrl: 'dialog-change-password.html',
  styleUrls: ['dialog-change-password.scss'],
})
export class DialogChangePassword {
  passwordForm: any;

  constructor(
    private loaderService: LoaderService,
    public dialogRef: MatDialogRef<DialogChangePassword>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private coreService: CoreService,
    public apiUsersServices: UsersService,
    public formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.createForm();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  createForm() {
    this.passwordForm = this.formBuilder.group({
      currentPassword: ['', [Validators.required, Validators.minLength(8)]],
      newPassword: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(8)]],
    });
  }

  changePassword() {
    let dataForm = { ...this.passwordForm.value };
    this.loaderService.show();
    this.apiUsersServices.changePassword(dataForm).subscribe({
      next: (value) => {
        this.loaderService.hide();
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: { text: value.message },
        });
        if (value.status) {
          this.dialogRef.close();
        }
      },
      error: (err) => {
        this.loaderService.hide();
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: { text: 'Hubo un error al procesar tu solicitud' },
        });
        console.error(err);
      },
    });
  }

  get currentPassword() {
    return this.passwordForm.get('currentPassword');
  }
  get newPassword() {
    return this.passwordForm.get('newPassword');
  }
  get confirmPassword() {
    return this.passwordForm.get('confirmPassword');
  }

  getErrorMessage(control: string): string {
    const controlErrors = this.passwordForm.get(control)?.errors;
    if (!controlErrors) return '';

    if (controlErrors.required) return 'Este campo es requerido';
    if (controlErrors.minlength) return 'Longitud inválida';
    return '';
  }
}

@Component({
  selector: 'dialog-delete-account',
  templateUrl: 'dialog-delete-account.html',
  styleUrls: ['dialog-delete-account.scss'],
})
export class DialogDeleteAccount {
  constructor(
    public dialogRef: MatDialogRef<DialogDeleteAccount>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  cancel(): void {
    this.dialogRef.close(false);
  }

  confirm(): void {
    this.dialogRef.close(true);
  }
}

@Component({
  selector: 'dialog-edit-profile',
  templateUrl: 'dialog-edit-profile.html',
  styleUrls: ['dialog-edit-profile.scss'],
})
export class DialogEditProfile implements OnInit {
  registerForm: any;
  dataLocalities: Observable<any[]> = of([]);
  dataProfile: any;
  maxDate?: Date;

  constructor(
    private loaderService: LoaderService,
    private coreService: CoreService,
    public dialogRef: MatDialogRef<DialogEditProfile>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public apiUsersServices: UsersService,
    public formBuilder: FormBuilder,
  ) {
    this.dataProfile = data;
    this.createForms();
  }

  ngOnInit(): void {
    this.maxDate = moment().subtract(18, 'years').toDate();
    this.loadProfile();
  }

  loadProfile(): void {
    const profile = this.dataProfile;

    if (!profile) {
      return;
    }

    let phone = profile.phone || '';

    if (phone.startsWith('52')) {
      phone = phone.substring(2);
    }

    this.registerForm.patchValue({
      names: profile.names || '',
      last_name: profile.last_name || '',
      last_name2: profile.last_name2 || '',
      phone: phone,
      email: profile.email || '',
      birthdate: profile.birthdate ? new Date(profile.birthdate) : null,
      gender: profile.gender || '',
      gender_value: profile.gender_value || '',
      main_zip_code: profile.main_zip_code || '',
      locality_id: profile.locality_id || '',
      municipality_id: profile.municipality_id || '',
      state_id: profile.state_id || '',
      municipality: profile.municipality || '',
      state: profile.state || '',
    });

    if (profile.main_zip_code) {
      this.searchDataZipCode();
    }
  }

  createForms(): void {
    this.registerForm = this.formBuilder.group({
      names: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(64),
        ],
      ],
      last_name: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(64),
        ],
      ],
      last_name2: [
        '',
        [
          Validators.required,
          Validators.minLength(3),
          Validators.maxLength(64),
        ],
      ],
      phone: [
        '',
        [
          Validators.required,
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.pattern(/^\d+$/),
        ],
      ],
      email: [
        '',
        [
          Validators.required,
          Validators.minLength(8),
          Validators.maxLength(128),
          Validators.email,
        ],
      ],
      birthdate: ['', [Validators.required]],
      gender: ['', [Validators.required]],
      gender_value: [''],
      main_zip_code: [
        '',
        [Validators.required, Validators.minLength(5), Validators.maxLength(5)],
      ],
      state_id: ['', [Validators.required]],
      municipality_id: ['', [Validators.required]],
      locality_id: ['', [Validators.required]],
      state: [''],
      municipality: [''],
    });
  }

  searchDataZipCode(): void {
    const theZipCode = this.registerForm.value.main_zip_code;

    if (!theZipCode || theZipCode.length !== 5) {
      return;
    }

    this.apiUsersServices.getLocalitiesByZipCode(theZipCode).subscribe({
      next: (value) => {
        if (!value.status) {
          return;
        }

        this.dataLocalities = of(value.data);

        if (this.dataProfile?.locality_id) {
          this.onSelectionLocality({
            value: String(this.dataProfile.locality_id),
          });
        }
      },
      error: () => {
        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: {
            text: 'No se pudieron consultar las localidades',
          },
        });
      },
    });
  }

  onSelectionLocality(event: any): void {
    let theLocality: any;

    this.dataLocalities.forEach((localities: any[]) => {
      theLocality = localities.find(
        (locality: any) => locality.id === parseInt(event.value, 10),
      );

      if (theLocality) {
        this.registerForm.get('locality_id').setValue(theLocality.id);
        this.registerForm
          .get('municipality_id')
          .setValue(theLocality.municipality.id);
        this.registerForm.get('state_id').setValue(theLocality.state.id);
        this.registerForm
          .get('municipality')
          .setValue(theLocality.municipality.name);
        this.registerForm.get('state').setValue(theLocality.state.name);
      }
    });
  }

  updateProfile(): void {
    if (this.registerForm.invalid) {
      this.registerForm.markAllAsTouched();
      return;
    }

    this.loaderService.show();

    const dataForm = {
      ...this.registerForm.value,
    };

    dataForm.birthdate = this.formatDate(dataForm.birthdate);
    dataForm.phone = '52' + dataForm.phone;

    if (dataForm.gender === 'O') {
      dataForm.gender_value = dataForm.gender_value || '';
    }

    this.apiUsersServices.updateProfile(dataForm).subscribe({
      next: (value) => {
        this.loaderService.hide();

        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: {
            text: value.message,
          },
        });

        if (value.status) {
          this.dialogRef.close(true);
        }
      },
      error: (err) => {
        this.loaderService.hide();

        console.error(err);

        this.coreService.emitSubjet.next({
          type: 'Snackbar',
          payload: {
            text: 'Hubo un error al actualizar tu perfil',
          },
        });
      },
    });
  }

  private formatDate(date: Date): string {
    return moment(date).format('YYYY-MM-DD');
  }

  close(): void {
    this.dialogRef.close(false);
  }

  get names() {
    return this.registerForm.get('names');
  }

  get last_name() {
    return this.registerForm.get('last_name');
  }

  get last_name2() {
    return this.registerForm.get('last_name2');
  }

  get phone() {
    return this.registerForm.get('phone');
  }

  get email() {
    return this.registerForm.get('email');
  }

  get birthdate() {
    return this.registerForm.get('birthdate');
  }

  get gender() {
    return this.registerForm.get('gender');
  }

  get gender_value() {
    return this.registerForm.get('gender_value');
  }

  get main_zip_code() {
    return this.registerForm.get('main_zip_code');
  }

  get locality_id() {
    return this.registerForm.get('locality_id');
  }

  getErrorMessage(control: string): string {
    const controlErrors = this.registerForm.get(control)?.errors;

    if (!controlErrors) {
      return '';
    }

    if (controlErrors.required) {
      return 'Este campo es requerido';
    }

    if (controlErrors.minlength) {
      return `La longitud mínima es: ${controlErrors.minlength.requiredLength}`;
    }

    if (controlErrors.maxlength) {
      return `La longitud máxima es: ${controlErrors.maxlength.requiredLength}`;
    }

    if (controlErrors.pattern) {
      return 'Formato inválido';
    }

    if (controlErrors.email) {
      return 'Correo electrónico inválido';
    }

    return '';
  }
}
